<script lang="ts">
	import FAQs from '$lib/components/landing-page/FAQs.svelte';
	import Features from '$lib/components/landing-page/Features.svelte';
	import Hero from '$lib/components/landing-page/Hero.svelte';
	import Products from '$lib/components/landing-page/Products.svelte';
	import Contact from '$lib/components/landing-page/Contact.svelte';
	import LSPPartners from '$lib/components/landing-page/LSPPartners.svelte';
	import {
		heroData,
		featuresData,
		contactData,
		faqItems,
		productsData,
		lspPartnersData
	} from '$lib/components/landing-page/config';
	import {
		HOME_META_DESCRIPTION,
		HOME_META_KEYWORDS,
		HOME_PAGE_TITLE,
		homeJsonLdScriptContent
	} from '$lib/seo/home';
	import { absoluteUrl } from '$lib/seo/publicBase';

	const canonical = absoluteUrl('/');
	const ogImage = absoluteUrl('/images/hero-people.webp');
	const jsonLd = homeJsonLdScriptContent(faqItems);
	// \u003c avoids `<script` in source — Svelte would treat it as a second `<script>` block.
	const jsonLdTag = '\u003cscript type="application/ld+json">' + jsonLd + '\u003c/script>';
</script>

<svelte:head>
	<title>{HOME_PAGE_TITLE}</title>
	<meta name="description" content={HOME_META_DESCRIPTION} />
	<meta name="keywords" content={HOME_META_KEYWORDS} />
	{#if canonical}
		<link rel="canonical" href={canonical} />
	{/if}
	<meta property="og:type" content="website" />
	<meta property="og:title" content={HOME_PAGE_TITLE} />
	<meta property="og:description" content={HOME_META_DESCRIPTION} />
	{#if canonical}
		<meta property="og:url" content={canonical} />
	{/if}
	{#if ogImage}
		<meta property="og:image" content={ogImage} />
	{/if}
	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:title" content={HOME_PAGE_TITLE} />
	<meta name="twitter:description" content={HOME_META_DESCRIPTION} />
	{#if ogImage}
		<meta name="twitter:image" content={ogImage} />
	{/if}
	<!-- eslint-disable-next-line svelte/no-at-html-tags -- JSON-LD is escaped JSON from our own builder, not user input -->
	{@html jsonLdTag}
</svelte:head>

<Hero {heroData} />
<Features {featuresData} />
<Products {productsData} />
<FAQs {faqItems} />
<Contact {contactData} />
<LSPPartners {lspPartnersData} />
